/** returns Portfolio - List of products subscribed by the client
@return { Array }
*/
export const getPortfolioList = state => {
    return state.portfolioList.accountWithProducts
}
